// Port of api/fuel/app/classes/controller/api/monty/groups.php
import F from 'offline/filter/constants'
import { runOwnerEndpoint } from 'offline/api/monty'

export default function(params) {
	if (!params.slug && params.name) params = Object.assign({}, params, { slug: params.name })
	return runOwnerEndpoint(params, F.OWNER_GROUP)
}
